const formatDateTime = date => {
  const d = new Date(date);
  return d.toLocaleString('sv-SE', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
};

export default formatDateTime;
